import { expand } from 'uri-template-lite';
import { apiClient } from '../../../common/ApiClient';
import { createApiQueryHook } from '../../../common/queryClient/createApiQueryHook';
import { AlgorithmUrl } from './AlgorithmUrl';
import { AlgorithmBasicSchema } from '../schema/AlgorithmBasicSchema';
import { AlgorithmBasicType } from '../schema/types';

type AlgorithmsOverviewQueryParams = {
  dataObjectVersionId: number;
};

const getAlgorithmsOverview = (params?: AlgorithmsOverviewQueryParams) =>
  apiClient
    .get<AlgorithmBasicType[]>(expand(AlgorithmUrl.overview, params))
    .then((response) => AlgorithmBasicSchema.array().parse(response.data));

export const useListAlgorithmsOverviewQuery = createApiQueryHook(
  ['data-object-algorithms-overview'],
  getAlgorithmsOverview
);
